__turbopack_context__.v({
  "employee-card-grid": "_8Nqx_W_employee-card-grid",
  "grid-section": "_8Nqx_W_grid-section",
  "grid-title": "_8Nqx_W_grid-title",
});
